function AudioEffect(file) {
	this.file = file;
	this.muted = false;
	this.audio = new Audio(file);
	this.volume = 1;
	this.fade_dt = 0.01;
}

AudioEffect.prototype.setLoop = function(b) {
	this.loop = b;
	this.audio.loop = b;
}

AudioEffect.prototype.setVolume = function(v) {
	this.volume = v;
	if (this.audio) this.audio.volume = this.volume;
}

AudioEffect.prototype.fadeVolume = function(v) {
	if (v != this.volume) this.volume += (v > this.volume ? this.fade_dt : - this.fade_dt);
	if (Math.abs(this.volume) < 0.01) this.volume = 0;
	if (this.audio) this.audio.volume = this.volume;
}

AudioEffect.prototype.setMuted = function(b) {
	this.muted = b;
	if (this.audio) this.audio.muted = this.muted;
}

AudioEffect.prototype.play = function() {
	this.audio.volume = this.volume;

	self = this;

	var promise = new Promise(function(resolve, reject) {
		var handle = null;
		handle = self.audio.play().then(function() {
//			Volume.checkVisibility();
			resolve(self.audio);
		}, function(resp) {
			if (resp.name == "NotAllowedError") {
				setTimeout(function() { self.play(); }, 2000);
			} else {
				reject(resp);
			}
		});
	});

	//if (handle) return handle;
	return promise;
}

AudioEffect.prototype.pause = function() {
	this.audio.pause();
}

AudioEffect.prototype.playRange = function(from, to) {
	this.audio.currentTime = from;

	var res = this.audio.play();
	this.from = from;
	this.to = to;

	var self = this;
	this.paudio_event = this.audio.addEventListener('timeupdate', function(event) {
		if (self.to != undefined && self.to > 0) {
			if (self.audio.currentTime >= self.to) {
				if (!self.loop)self.audio.pause();
				self.audio.currentTime = from;
			}
		}
	});

	return res;
}